// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1gkYj","label":"SetPasswdForm_label__3taxy"};